var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-tiket-wrapper"},[_c('div',{staticClass:"tit"},[_vm._v(_vm._s(_vm.ticketQuota))]),_c('List',{attrs:{"data":_vm.listData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }